import { render } from "./DjRestartTab.vue?vue&type=template&id=457cac99&scoped=true"
import script from "./DjRestartTab.vue?vue&type=script&lang=js"
export * from "./DjRestartTab.vue?vue&type=script&lang=js"

import "./DjRestartTab.vue?vue&type=style&index=0&id=457cac99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-457cac99"

export default script